/**
 * @description rest api endpoints
 */
import { basepath } from './endpointsBasePaths';
import { Endpoints } from './types.d';

/**
 * @description rest api endpoints
 */
export const endpoints = {
  // prusuki WP BE
  [Endpoints.info]: `${basepath.v1}/${Endpoints.info}`,
  [Endpoints.article]: `${basepath.v1}/helps`, // alias
  [Endpoints.articles]: `${basepath.v1}/helps`,
  [Endpoints.guide]: `${basepath.v1}/${Endpoints.guides}`, // alias
  [Endpoints.guides]: `${basepath.v1}/${Endpoints.guides}`,
  [Endpoints.steps]: `${basepath.v1}/${Endpoints.steps}`,
  [Endpoints.category]: `${basepath.v1}/categories`, // alias
  [Endpoints.categories]: `${basepath.v1}/${Endpoints.categories}`,
  [Endpoints.feedback]: `${basepath.v1}/${Endpoints.feedback}`,
  [Endpoints.comments]: `${basepath.edge}/${Endpoints.comments}`,
  [Endpoints.commentActionFrontend]: `${basepath.edge}/${Endpoints.comments}`,
  [Endpoints.backendComments]: `${basepath.v1}/${Endpoints.comments}`,
  [Endpoints.commentAction]: `${basepath.v2}/${Endpoints.comments}`,
  [Endpoints.downloads]: `${basepath.v1}/prusa3d_downloads`,
  [Endpoints.materials]: `${basepath.v1}/${Endpoints.materials}`,
  [Endpoints.user]: `${basepath.help}/${Endpoints.user}`,
  [Endpoints.qrCode]: `${basepath.v1}/qr_codes`,
  [Endpoints.logout]: `${basepath.help}/${Endpoints.logout}`,
  [Endpoints.related]: `${basepath.v1}/${Endpoints.related}`,
  [Endpoints.tooltips]: `${basepath.v1}/${Endpoints.tooltips}`,
  [Endpoints.productPageContentBlocks]: `${basepath.v1}/view`,
  [Endpoints.pdfs]: `${basepath.v1}/${Endpoints.pdfs}`,
  [Endpoints.search]: `${basepath.v1}/${Endpoints.search}`,
  [Endpoints.googleVertexSearch]: `${basepath.googleVertexSearch}`,
  [Endpoints.vertex]: `${basepath.edge}/${Endpoints.vertex}`,
  [Endpoints.forumListTopics]: `${basepath.forum}/list-topics`,
  [Endpoints.forumCategoryById]: `${basepath.forum}id`,
  [Endpoints.recaptcha]: `${basepath.edge}/${Endpoints.recaptcha}`,
  [Endpoints.profiles]: `${basepath.slicer}`,
  [Endpoints.getRedirect]: `${basepath.v1}/get_redirect`,
} as const;

export const freshDataEndpoints = [
  'comments',
  'commentAction',
  'backendComments',
  'commentActionFrontend',
  'feedback',
  'user',
  'logout',
  'forumCategoryById',
  'forumListTopics',
  'qrCode',
  // 'search', //TODO: Verify that this can be cached without issues
  // 'pdfs', TODO: Make sure that this causes no errors.
  // 'googleVertexSearch', // SAME as above
  // 'downloads',
  'vertex',
  'recaptcha',
  'profiles',
  'getRedirect',
];

// /**
//  * @description data types for rest api endpoints
//  */
// export type Endpoints = keyof typeof endpoints;

export type EndpointTypeMap = {
  [K in Endpoints]: K extends 'articles' | 'article'
    ? ArticleData[]
    : K extends 'guides' | 'guide'
    ? GuideData[]
    : K extends 'steps'
    ? StepData[]
    : K extends 'info'
    ? InfoData
    : K extends 'categories' | 'category'
    ? CategoryData[]
    : K extends 'forumCategoryById' | 'forumListTopics'
    ? ForumTopics[]
    : K extends 'materials'
    ? MaterialData[]
    : K extends 'qrCode'
    ? QRCodeData
    : K extends 'search'
    ? SearchItem[]
    : K extends 'related'
    ? ArticleData[]
    : K extends 'productPageContentBlocks'
    ? ViewData[]
    : K extends 'pdfs'
    ? PdfData[]
    : K extends 'googleVertexSearch' | 'vertex'
    ? VertexSearchData[]
    : K extends 'downloads'
    ? Prusa3dDownload[]
    : K extends 'getRedirect'
    ? RedirectData[]
    : never;
};
